// extracted by mini-css-extract-plugin
module.exports = {"modal":"2faModal_modal__3IJyb","modal-content":"2faModal_modal-content__2Aalp","close":"2faModal_close__13E6B","modalButton":"2faModal_modalButton__1IwIZ"};